module.exports = __webpack_public_path__ + "static/media/game-over.f6f0c090.jpg";